import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "@/lib/auth";

export default function RequireAuth({ children }) {
    const location = useLocation();
    if (!isAuthenticated()) {
        return (
            <Navigate
                to="/bbrgadminacc"
                replace
                state={{ from: location.pathname }}
            />
        );
    }
    return children;
}
